export const shouldHighlight = (
  active: boolean,
  startTime: number,
  currentTime: number
) => active && currentTime >= startTime;
